import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";

const stepper = [
  "退職者の基本情報登録",
  "添付書類の登録",
  "従業状況の登録確認",
  "退職した月以前6ヶ月の本俸月額登録",
  "退職手当金請求の順番登録",
  "源泉徴収票の登録",
  "登録内容の確認",
  "機構へ提出",
];

const fakeTableList: ITkFakeTableLineProps[] = [
  {
    keyword: "contractorName",
    type: "contractorAndNumber",
    contractorName: "契約者（法人）名",
    showLine: false,
  },
  {
    title: "",
    keyword: "title",
    type: "lineTitle",
  },
  {
    title: "職員番号",
    keyword: "staffNo",
    type: "text",
  },
  {
    title: "退職者名",
    keyword: "retireeName",
    type: "text",
  },
];

const fakeTableListFile: ITkFakeTableLineProps[] = [
  {
    title: "賃金台帳",
    keyword: "wages",
    type: "fileUpload",
    id: "1",
    showLine: false,
  },
  {
    title: "雇用契約書",
    keyword: "contractOfEmployment",
    type: "fileUpload",
    id: "2",
    showLine: false,
  },
];

const salaryTableHead: any = [
  {
    headTitle: "年月",
    helpText:
      "退職手当金の算定となる退職月前６か月間の年月です。退職日が月末でない場合は、退職月の前月から6か月間を遡ります。また、「ならない月」がある場合は、当該月を除きます。",
  },
  {
    headTitle: (
      <>
        俸給表の額<span className="required">【必須】</span>
      </>
    ),
    helpText: (
      <>
        共済契約者が給与規程で定める本俸月額を入力してください。ただし、給与規程で本俸が定められていない職員は、雇用契約書で定める労働条件をもとに計算した額となります。詳しくは、
        <a
          href={`${
            process.env.PUBLIC_URL ?? ""
          }/assets/pdf/≪別紙≫俸給表の額について.pdf`}
          target="_blank"
          rel="noreferrer"
        >
          こちら
        </a>
        をご確認ください。
        【注意点】実際の支給された額を記載するのではなく、給与規程や雇用契約書等に定められた額を記載してください。
      </>
    ),
  },
  {
    headTitle: "俸給の調整額手当",
    helpText: "「俸給の調整額」の対象となる手当の名称です。",
  },
  {
    headTitle: "俸給の調整額",
    helpText: (
      <>
        「俸給の調整額」対象手当として当機構が認めた手当があれば、金額を入力してください。登録されている手当以外の金額は計上することができません。未登録の場合は登録申請が必要です。
        俸給の調整額については、
        <a
          href={`${
            process.env.PUBLIC_URL ?? ""
          }/assets/pdf/≪別紙≫俸給の調整額について.pdf`}
          target="_blank"
          rel="noreferrer"
        >
          こちら
        </a>
        ご確認ください。
      </>
    ),
  },
  {
    headTitle: "俸給の手当入力",
    helpText:
      "「俸給の調整額」については、対象となる手当の明細ごとに入力する方法と合計額を入力する方法の２通りあります。希望する方法で入力をしてください。",
  },
];

export { stepper, fakeTableList, salaryTableHead, fakeTableListFile };
